import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisplayNameModule } from '@shared/ui/pipes/display-name/display-name.module';
import { IsMeModule } from '@shared/modules/comments/components/pipes/is-me/is-me.module';
import { IconModule } from '@shared/modules/common/icon/icon.module';
import { LoopTooltipModule } from '@shared/ui/tooltip/tooltip.module';
import { ContactModule } from '@shared/modules/contacts/components/contact/contact.module';
import { CopyValueModule } from '@shared/ui/kit/copy-value/copy-value.module';
import { ContactsPipesModule } from '@shared/modules/contacts/components/pipes/contacts-pipes.module';
import { DropdownModule } from '@shared/ui/dropdown/dropdown.module';
import { FancyDateModule } from '@shared/shared/fancy-date/shell/fancy-date.module';
import { ContactAvatarModule } from '@shared/modules/contacts/components/contact-avatar/contact-avatar.module';
import { BrowserExternalWindowHiddenDirective } from '@shared/ui/kit/dialog/browser-external-window-hidden.directive';
import { TimeAgoModule } from '@dta/ui/components/common/time-ago/time-ago.module';
import { SleepClickEventModule } from '@dta/ui/directives/sleep-click-event/sleep-click-event.module';
import { MailCommentHeaderComponent } from './mail-comment-header.component';
import { ContactsInformationPipe } from './internal/contacts-information.pipe';

@NgModule({
  declarations: [MailCommentHeaderComponent, ContactsInformationPipe],
  imports: [
    CommonModule,
    DisplayNameModule,
    TimeAgoModule,
    IsMeModule,
    IconModule,
    SleepClickEventModule,
    LoopTooltipModule,
    ContactModule,
    CopyValueModule,
    ContactsPipesModule,
    DropdownModule,
    FancyDateModule,
    ContactAvatarModule,
    BrowserExternalWindowHiddenDirective
  ],
  exports: [MailCommentHeaderComponent]
})
export class MailCommentHeaderModule {}
